import { connect } from 'react-redux';

import adminPaymentGateways from '_store/_actions/adminPaymentGateways';

import ChargeStatusPaymentGateway from './ChargeStatusPaymentGateway';

const mapStateToProps = state => {
  const {
    isLoadingChargeStatusGateway,
    chargeStatusPaymentGateways,
    chargeStatus,
    paymentGateways,
  } = state.adminPaymentGateways;

  return {
    chargeStatusPaymentGateways,
    chargeStatus,
    paymentGateways,
    isLoading: isLoadingChargeStatusGateway,
  };
};

const mapDispatchToProps = {
  onFetchChargeStatusGateway: adminPaymentGateways.fetchAdminChargeStatusGateway,
  onCreateChargeStatusGateway: adminPaymentGateways.createAdminChargeStatusGateway,
  onUpdateChargeStatusGateway: adminPaymentGateways.updateAdminChargeStatusGateway,
  onDeleteChargeStatusGateway: adminPaymentGateways.deleteAdminChargeStatusGateway,
  onFetchChargeStatus: adminPaymentGateways.fetchAdminChargeStatus,
  onFetchPaymentGateways: adminPaymentGateways.fetchAdminPaymentGateways,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChargeStatusPaymentGateway);
